module.exports = __webpack_public_path__ + "img/icon18.a5d6cbba.svg";